import React from 'react';
import { ExternalLinkIcon } from '../icons/icons';
import { ButtonStyleType } from '../../../constants/button-style-type';
import styles from './link-button.module.scss';

type Props = {
  link: string;
  text: string;
  newTab?: boolean;
  disclaimer?: boolean;
  linkStyle?: ButtonStyleType;
  onClick?: () => void;
};

export default function LinkButton({
  onClick,
  link,
  text,
  newTab = true,
  disclaimer = false,
  linkStyle,
}: Props) {
  return (
    <>
      <a
        className={`${styles.link} ${linkStyle ? styles[`link-secondary`] : ``}`}
        href={link}
        target={newTab ? `_blank` : `_self`}
        rel='noreferrer'
        onClick={onClick}
      >
        {newTab && (
          <span className='me-2 d-flex align-items-center'>
            <ExternalLinkIcon />
          </span>
        )}
        <span className={`${styles[`link-text`]}`}>{text}</span>
        {newTab && <span className='visually-hidden'>This link will open in a new tab</span>}
      </a>
      {disclaimer && (
        <p className='external-link-disclaimer mt-3 mb-0'>
          INTO is not responsible for the content of external sites
        </p>
      )}
    </>
  );
}
